"use strict";
import Vue      from 'vue/dist/vue.common.js';

const NavItem = Vue.component('ts-nav-item', {
  // template: "INLINE"

  props: {
    active: {
      default: false,
      required: false,
      type: Boolean
    },
    index: {
      required: true,
      type: Number
    },
    current: {
      default: -1,
      required: true,
      type: Number
    }
  },

  computed: {
    isActive() {
      return this.current === this.index;
    }
  },

  methods: {
    toggle() {
      this.$emit('toggle', this.index);
    }
  }
});

export default NavItem;